export default "__VITE_ASSET__39d8ec87__"